import { useMemo } from 'react';
import { cn } from '@shared/utils';

export function formatAmount(amount?: number) {
  if (amount === null || typeof amount === 'undefined') return null;
  const c = '';
  const absAmount = amount >= 0 ? amount : -amount;
  const d = Math.floor(absAmount);
  const n = (
    Array.from(d.toString())
      .reverse()
      .join('')
      .match(/\d{1,3}/g) || []
  )
    .join(' ')
    .split('')
    .reverse()
    .join('');
  const sign = amount >= 0 ? '' : '-';
  const p = Math.round((absAmount - d) * 100);
  let result = `${c}${sign}${n}`;
  result += `.${p < 10 ? '0' : ''}${p}`;
  return result;
  //.${p < 10 ? '0' : ''}${p}`;
}

interface TransactionTileType {
  className?: string;
  date?: string;
  currency?: string;
  amount?: string;
  merchant?: string;
  typeOfDispute?: string;
  natureOfDispute?: string;
  onEdit: (index: number) => void;
  onDelete: (index: number) => void;
  index: number;
}

export const TransactionTile = (props: TransactionTileType) => {
  const dateStr = useMemo(() => {
    return props.date ? [...props.date.split('-').reverse()].join('/') : props.date;
  }, [props.date]);

  const amountStr = useMemo(() => {
    return formatAmount(Number(props.amount));
  }, [props.amount]);

  return (
    <div className={cn('w-[calc(50%-48px)] rounded-lg bg-white p-4', props.className)}>
      <div className='mb-[10px] flex items-start justify-between'>
        <span className='text-[#4c4c4c80]'>Date</span>
        <span className='text-[#0f0f11]'>{dateStr}</span>
      </div>
      <div className='mb-[10px] flex items-start justify-between'>
        <span className='text-[#4c4c4c80]'>Amount</span>
        <span className='text-[#0f0f11]'>
          <span className='text-[#4c4c4c80]'>{props.currency} </span>
          <span className='text-[#27c137]'>{amountStr}</span>
        </span>
      </div>
      <div className='mb-[10px] flex items-start justify-between'>
        <span className='text-[#4c4c4c80]'>Merchant</span>
        <span className='text-[#0f0f11]'>{props.merchant}</span>
      </div>
      <div className='mb-[10px] flex items-start justify-between'>
        <span className='text-[#4c4c4c80]'>Type of dispute</span>
        <span className='text-[#0f0f11]'>{props.typeOfDispute}</span>
      </div>
      <div className='mb-[10px] flex items-start justify-between'>
        <span className='text-[#4c4c4c80]'>Nature of dispute</span>
        <span className='text-[#0f0f11]'>{props.natureOfDispute}</span>
      </div>
      <div className='flex justify-between overflow-hidden rounded-lg bg-[#fafafa]'>
        <button className='grow-1 cursor-pointer border-none bg-transparent p-2 text-[#4c4c4c80]' onClick={() => props.onEdit(props.index)}>
          Edit
        </button>
        <div className='h-full w-[1px] bg-[#4c4c4c1a]' />
        <button className='grow-1 cursor-pointer border-none bg-transparent p-2 text-[#4c4c4c80]' onClick={() => props.onDelete(props.index)}>
          Delete
        </button>
      </div>
    </div>
  );
};
